import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useBusinessContext } from '../../../core/hooks';
import { DashboardBusinessContext } from '../../config';
import { useDashboardNetworkServiceEvents } from '../../hooks';
import { DashboardContact } from '../DashboardContact/DashboardContact';
import { DashboardMaintenanceWorks } from '../DashboardMaintenanceWorks/DasbhoardMaintenanceWorks';
import { DashboardNotifications } from '../DashboardNotifications/DashboardNotifications';
import { DashboardServiceStatus } from '../DashboardServiceStatus/DashboardServiceStatus';

export const Dashboard: FunctionComponent = () => {
  useBusinessContext(DashboardBusinessContext);
  const { incidentsUpdates, maintenanceWorksUpdates, statusUpdates } = useDashboardNetworkServiceEvents();

  return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 4, pt: 8, gap: 3 }}>
    <Box sx={{ display: 'flex', gap: 3 }}>
      <Box sx={{ width: '100%' }}>
        <DashboardServiceStatus statusUpdates={statusUpdates} />
      </Box>
      <Box>
        <DashboardContact />
      </Box>
    </Box>
    <DashboardMaintenanceWorks maintenanceWorksUpdates={maintenanceWorksUpdates} />
    <DashboardNotifications incidentsUpdates={incidentsUpdates} />
  </Box>;
};